import { render, staticRenderFns } from "./SelectTagsModal.vue?vue&type=template&id=4869e9c2&scoped=true&"
import script from "./SelectTagsModal.vue?vue&type=script&lang=ts&"
export * from "./SelectTagsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTagsModal.vue?vue&type=style&index=0&id=4869e9c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4869e9c2",
  null
  
)

export default component.exports